import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AccountType, AutoAttendantEntitySearchResult } from '../../shared/models/generated/ziroModels';

@Injectable({ providedIn: 'root' })
export class TeamsAutoAttendantsAccountSearchResource {
  private _httpClient = inject(HttpClient);

  search(tenantId: string, query: string, accountType: AccountType): Observable<AutoAttendantEntitySearchResult[]> {
    return this._httpClient.get<AutoAttendantEntitySearchResult[]>(
      `/services/microsoft/auto-attendant-management/tenants/${tenantId}/accounts/search?q=${query}&accountType=${accountType}&limit=100`,
    );
  }
}
